function NotFound() {
  return <h1>Hello, from NotFound page</h1>;
}

export { NotFound };
